import React from 'react';
import SettingsPage from 'routes/settings/SettingsPage';
import UsersPublisherSettings from './UsersPublisherSettings';

export default function PublisherSettings() {
  return (
    <SettingsPage>
      <UsersPublisherSettings />
    </SettingsPage>
  );
}
